// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Form,
  Image,
  Input,
  Message,
  Modal,
  Radio,
  Select,
  Space,
  Table,
  TableColumnProps,
  Tabs,
  Upload
} from '@arco-design/web-react';
import dayjs from 'dayjs';

import './index.scss';

import { get, post } from '../requestNew';
import { baseUrl } from '../utils';
import { Item, TypeItem } from './types';
import SystemNotifications from './SystemNotifications';

const URL_UPLOAD = baseUrl + '/common/uploadFile';

const msgTypeOpt = [
  { label: '文本', value: '1' },
  { label: '图片', value: '2' }
];

const FormItem = Form.Item;
const TextArea = Input.TextArea;

const formItemLayout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 16
  }
};

function MessageList() {
  const [form] = Form.useForm<Item>();
  const [formSearch] = Form.useForm<Item>();
  const [options, setOptions] = useState<[]>([]);
  const [optionsMap, setOptionsMap] = useState<Record<string, string>>({});
  const [visible, setVisible] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataList, setDataList] = useState<Item[]>([]);

  const formRef = useRef<any>({});

  const columns: TableColumnProps[] = [
    {
      title: '序号',
      width: 50,
      render: (_, record, i) => i + 1
    },
    {
      title: '公告类型',
      dataIndex: 'senderNickname',
      width: 80,
      render: text => text || '-'
    },
    {
      title: '消息内容',
      dataIndex: 'content',
      width: 400,
      render: (text, record) => {
        if (record.contentType === 1) {
          return text;
        } else {
          const src = text;
          return src && src.indexOf('http') === 0 ? (
            <Image src={src} width={50} height={50} preview={true} style={{ borderRadius: 4 }} />
          ) : (
            '-'
          );
        }
      }
    },
    {
      title: '发布时间',
      dataIndex: 'createTime',
      width: 100,
      render: text => dayjs(text).format('YYYY-MM-DD HH:mm')
    }
    // {
    //   title: '操作',
    //   dataIndex: 'action',
    //   width: 120,
    //   render: (_, record: Item) => (
    //     <>
    //       <Button className="btn" type="text" onClick={() => edit(record)}>
    //         编辑
    //       </Button>
    //       <Popconfirm focusLock title="提示" content="是否确认删除?" onOk={() => del(record)}>
    //         <Button className="btn" type="text" status="danger">
    //           删除
    //         </Button>
    //       </Popconfirm>
    //     </>
    //   )
    // }
  ];

  const getCategories = () => {
    get<any>('/backend/systemMessage/categories')
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const list = (data || []).map((item: TypeItem) => {
            const { peerOpenId, name } = item;
            return { label: name, value: peerOpenId };
          });
          setOptions(list);

          const map: Record<string, string> = {};
          list.forEach((item: { value: string; label: string }) => {
            map[item.value] = item.label;
          });
          setOptionsMap(map);
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      });
  };

  const getList = (page?: { pageNum: number; pageSize: number }) => {
    const params = {
      ...formSearch.getFieldsValue(),
      pageNum,
      pageSize,
      ...page
    };

    get<any>('/backend/systemMessage/history', params)
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const { list, total } = data;
          setTotal(total);
          setDataList(list || []);
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      });
  };

  const search = () => {
    setPageNum(1);
    setPageSize(20);
    const params = {
      pageNum: 1,
      pageSize: 20
    };
    getList(params);
  };

  const add = () => {
    formRef.current = {};
    form.resetFields();
    form.setFieldsValue({ contentType: '1' });
    setVisible(true);
  };
  const del = (record: Item) => {
    // post(`/notice/delete?id=${record.id}`)
    //   .then((res: any) => {
    //     const { code, message } = res || {};
    //     if (code === 200) {
    //       Message.success('删除成功！');
    //       getList();
    //     } else {
    //       Message.error(message);
    //     }
    //   })
    //   .catch(() => {
    //     Message.error('网络错误!');
    //   });
  };

  const edit = (record: Item) => {
    // formRef.current = record;
    // form.setFieldsValue({ ...record });
    // setVisible(true);
  };
  const editCancel = () => {
    formRef.current = {};
    setVisible(false);
    form.resetFields();
  };
  const onOk = () => {
    const { contentType, peerOpenId, contentText, contentImage } = form.getFieldsValue();
    if (contentType === '1' && !contentText) {
      Message.error('请输入内容!');
      return;
    }
    if (contentType === '2' && !contentImage) {
      Message.error('请选上传图片!');
      return;
    }

    const data = {
      peerOpenId,
      contentType,
      content: contentType === '1' ? contentText : contentImage
    };
    post('/backend/systemMessage/push', data)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          getList();
          editCancel();
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      });
  };

  useEffect(() => {
    getList();
  }, [pageNum, pageSize]);
  useEffect(() => {
    getCategories();
  }, []);

  return (
    <div className="message table-flex">
      <Space style={{ flexWrap: 'wrap' }}>
        <Form style={{ width: '100%' }} autoComplete="off" layout="inline" form={formSearch}>
          {/* <FormItem label="消息内容" field="notice">
            <Input style={{ width: 200 }} />
          </FormItem> */}
          <FormItem label="类型" field="peerOpenId">
            <Select style={{ width: 100 }} allowClear options={options}></Select>
          </FormItem>
          <FormItem>
            <Button type="primary" onClick={search}>
              查询
            </Button>
          </FormItem>
          {/* <FormItem>
            <Button type="outline" onClick={handleReset}>
              重置
            </Button>
          </FormItem> */}
          <FormItem>
            <Button className="filter-item" type="primary" onClick={add}>
              新增
            </Button>
          </FormItem>
        </Form>
      </Space>
      <div className="table-content">
        <Table
          rowKey="id"
          columns={columns}
          data={dataList}
          className="table-scroll"
          pagination={{
            sizeCanChange: true,
            pageSize,
            total,
            showTotal: true,
            current: pageNum,
            onChange: (num, size) => {
              setPageNum(num);
              if (size && size !== pageSize) {
                setPageSize(size);
              }
            }
          }}
          scroll={{ y: '100%', x: '100%' }}
        />
      </div>
      <Modal
        title={formRef.current.id ? '编辑' : '新增'}
        visible={visible}
        onCancel={editCancel}
        onOk={onOk}
        unmountOnExit
      >
        <Form {...formItemLayout} form={form}>
          <FormItem label="类型" field="peerOpenId">
            <Select placeholder="请选择消息类型" options={options} />
          </FormItem>
          <Form.Item field="contentType" label="消息类型">
            <Radio.Group>
              {msgTypeOpt.map(item => {
                return (
                  <Radio value={item.value} key={item.value}>
                    {item.label}
                  </Radio>
                );
              })}
            </Radio.Group>
          </Form.Item>
          <Form.Item noStyle shouldUpdate={(prev, next) => prev.contentType !== next.contentType}>
            {values => {
              return values.contentType === '1' ? (
                <FormItem label="消息内容" field="contentText">
                  <TextArea placeholder="" />
                </FormItem>
              ) : (
                <FormItem label="消息图片" field="contentImage">
                  <Upload
                    action={URL_UPLOAD}
                    headers={{
                      Authorization: `${localStorage.getItem('authToken')}`
                    }}
                    defaultFileList={
                      form.getFieldValue('contentImage')
                        ? [{ url: form.getFieldValue('contentImage'), uid: '-1', name: 'contentImage' }]
                        : []
                    }
                    onChange={(_, file) => {
                      if (file?.response?.data) {
                        form.setFieldValue('contentImage', file.response.data);
                      }
                    }}
                    onRemove={() => {
                      form.setFieldValue('contentImage', '');
                    }}
                    limit={1}
                    imagePreview
                    listType="picture-card"
                    multiple={false}
                    accept="image/*"
                  />
                </FormItem>
              );
            }}
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default function MessageManagement() {
  return <Tabs className="message-management" defaultActiveTab="legacy" style={{ padding: '0 20px' }}>
    <Tabs.TabPane key="legacy" title="官方 / 比赛 / 资讯消息"><MessageList /></Tabs.TabPane>
    <Tabs.TabPane key="notification" title="系统通知"><SystemNotifications /></Tabs.TabPane>
  </Tabs>;
}
